<template>
  <vx-card v-show="isCardActiveLocal" class="mt-3">
    <div v-if="quizType == 'graded'" class="vx-row">
      <div class="flex flex-wrap items-center justify-center">
        <p class="ml-4 mr-2">Score: </p>
        <p><strong>{{ question.assessment.awardedPoints + " " + "/" + " " + question.assessment.maxPoints }}</strong></p>
      </div>
    </div>
    <div v-if="question.assessment.assessorComment" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label><strong>{{ viewOnly ? "Teacher Comment:" : "Assessor Comment:" }}</strong></label>
        <vs-textarea readOnly v-model="question.assessment.assessorComment" />
      </div>
    </div>
    <div v-if="!viewOnly" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label>Your Comment:</label>
        <vs-textarea v-model="question.assessment.studentComment" />
      </div>
    </div>
  </vx-card>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      quizType: {
        type: String,
        required: false
      },
      viewOnly: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
        }
      },
    },
    mounted() {
      
    },
  }

</script>

<style lang="scss">

</style>
